// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"EditPane_inputGroup__lT4Zq"};